import { apiCall } from "../service/api-service";

export const getQuotationListApi = async (params) => {
  return apiCall("GET", "quotation", null, { params });
};

export const createQuotationApi = async (data) => {
  return apiCall("POST", "quotation", data);
};

export const sendQuotationMailApi = async (id, data) => {
  return apiCall("POST", `quotation/send_mail/${id}`, data);
};

export const updateQuotationApi = async (data, id) => {
  return apiCall("PUT", `quotation/${id}`, data);
};

export const updateQuotationStatusApi = async (data, id) => {
  return apiCall("PUT", `quotation/status/${id}`, data);
};

export const extendQuotationValidityApi = async (id, data) => {
  return apiCall("PUT", `quotation/extend_validity/${id}`, data);
};

export const getCustomerAddressApi = async (id) => {
  return apiCall("POST", "check_customer_address", { customer_id: id });
};

export const getStateTaxApi = async (id) => {
  return apiCall("POST", "check_state_tax", { state_id: id });
};

export const getCustomerDetailsApi = async (id) => {
  return apiCall("GET", `get_customer_details/${id}`);
};

export const getLeadDetailsApi = async (id) => {
  return apiCall("GET", `get_lead_details/${id}`);
};

export const getQuotationDetailsApi = async (id) => {
  const response = await apiCall("GET", `quotation/edit/${id}`);
  return response.data;
};

export const getQuotationDataApi = async (id) => {
  const response = await apiCall("GET", `quotation/view/${id}`);
  return response.data;
};

export const getMailTemplateApi = async (id, templateId) => {
  const response = await apiCall("GET", `quotation/mail_template/${id}`, null, {
    params: templateId ? { template_id: templateId } : undefined,
  });
  return response.data;
};

export const getEmailTemplatesApi = async (code) => {
  const response = await apiCall("GET", "quotation/email_templates", null, { params: { code } });
  return response.data;
};

export const previewQuotationTemplateApi = async (id, templateId) => {
  const response = await apiCall("GET", `quotation/preview_template/${id}`, null, {
    params: { template_id: templateId },
  });
  return response.data;
};

export const getOrgCurrencyApi = async () => {
  const response = await apiCall("GET", "get_org_currency");
  return response.data;
};

export const getQuotationHistoriesApi = async (id) => {
  const response = await apiCall("GET", `quotation_histories/${id}`);
  return response.data;
};

export const getQuotationWorkflowApi = async (id) => {
  return apiCall("GET", `quotation/workflow/${id}`);
};

export const bulkDeleteQuotationApi = async (payload) => {
  const data = Array.isArray(payload) ? { ids: payload } : payload;
  return apiCall("DELETE", "quotation/bulk_delete", data);
};

export const deleteQuotationApi = async (id) => {
  return apiCall("DELETE", `quotation/delete/${id}`);
};

export const bulkDeleteLeadApi = async (payload) => {
  const data = Array.isArray(payload) ? { id: payload } : payload;
  return apiCall("DELETE", "lead/bulkdelete", data);
};

export const deleteLeadApi = async (id) => {
  return apiCall("DELETE", `lead/delete/${id}`);
};

export const addQuotationAttachmentApi = async (quotationId, attachmentData) => {
  return apiCall("POST", `quotation/add_attachment/${quotationId}`, attachmentData);
};

export const addQuotationAttachmentsBulkApi = async (quotationId, attachmentArray) => {
  // Send multiple attachments in single API call for better performance
  return apiCall("POST", `quotation/add_attachment/${quotationId}`, {
    attachments: attachmentArray,
  });
};

export const getQuotationAttachmentsApi = async (quotationId) => {
  return apiCall("GET", `quotation/attachment/${quotationId}`);
};

export const removeQuotationAttachmentApi = async (attachmentId) => {
  return apiCall("DELETE", `quotation/remove_attachment/${attachmentId}`);
};

export const askQuotationChatApi = async (payload) => {
  return apiCall("POST", "quotation/ai_chat", payload);
};

export const getQuotationAiProvidersApi = async () => {
  return apiCall("GET", "quotation/ai_providers");
};

export const getQuotationAiSummaryApi = async (id, payload = {}) => {
  return apiCall("POST", `quotation/ai_summary/${id}`, payload);
};
